import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

export const CarLoader = () => {
  return (
    <>
      {/* <img
        style={{ height: 300, width: 300 }}
        src={"./src/_images/vehicleSearch.gif"}
        alt="Loading..."
      /> */}
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        direction="column"
      >
        <Grid style={{ marginTop: -80, zIndex: 99, width: 280 }}>
          <Typography variant="h5" style={{ fontSize: "1.2rem" }}>
            Give us a moment please, while we search for your vehicle...
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
